module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "home"
  }, [_vm._m(0), " ", _h('div', {
    staticClass: "card-container"
  }, [_h('div', [_vm._m(1), " ", _h('div', {
    staticClass: "card two-times sp",
    staticStyle: {
      "min-height": "338px"
    }
  }, [_vm._m(2), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  }), _vm._s(_vm.current.title)]), " ", _h('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.current.summary)
    }
  })]), " ", _h('div', {
    staticClass: "card-footer text-center"
  }, [_h('router-link', {
    class: 'btn btn-link',
    attrs: {
      "to": "pressure-point"
    }
  }, ["続きを読む"])])])]), " ", _h('div', [_h('div', {
    staticClass: "card",
    staticStyle: {
      "min-height": "544px"
    }
  }, [_vm._m(3), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('div', {
    staticClass: "overlay-container"
  }, [_h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.fbOverlay) ? _h('div', {
    staticClass: "overlay text-center"
  }) : _vm._e()]), " ", _h('iframe', {
    staticStyle: {
      "border": "none",
      "overflow": "hidden"
    },
    attrs: {
      "src": "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftodaseitai.tsubo%2F&tabs=timeline&width=290&height=350&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
      "width": "290",
      "height": "350",
      "scrolling": "no",
      "frameborder": "0",
      "allowTransparency": "true"
    }
  })])]), " ", _vm._m(4)])]), " ", _h('div', {
    staticClass: "card one-time pc"
  }, [_vm._m(5), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  }), _vm._s(_vm.current.title)]), " ", _h('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.current.summary)
    }
  })]), " ", _h('div', {
    staticClass: "card-footer text-center"
  }, [_h('router-link', {
    class: 'btn btn-link',
    attrs: {
      "to": "pressure-point"
    }
  }, ["続きを読む"])])]), " ", _vm._m(6), " ", _vm._m(7), " ", _h('div', {
    staticClass: "card three-times"
  }, [_vm._m(8), " ", _h('div', {
    staticClass: "card-body"
  }, [_vm._m(9), " ", _h('div', {
    staticClass: "overlay-container"
  }, [_h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mapOverlay) ? _h('div', {
    staticClass: "overlay text-center"
  }) : _vm._e()]), " ", _h('iframe', {
    attrs: {
      "width": "100%",
      "height": "300",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "src": "https://maps.google.co.jp/maps?f=q&source=embed&hl=ja&geocode=&q=%E6%84%9B%E7%9F%A5%E7%9C%8C%E5%90%8D%E5%8F%A4%E5%B1%8B%E5%B8%82%E7%91%9E%E7%A9%82%E5%8C%BA%E7%A5%9E%E5%89%8D%E7%94%BA%EF%BC%92%E4%B8%81%E7%9B%AE%EF%BC%92%EF%BC%90&brcurrent=3,0x60037a59f8a8c0c7:0xe3f7881e28c046a3,1&brv=21.22&sll=35.121352,136.933988&sspn=0.001729,0.002411&ie=UTF8&hq=&hnear=%E6%84%9B%E7%9F%A5%E7%9C%8C%E5%90%8D%E5%8F%A4%E5%B1%8B%E5%B8%82%E7%91%9E%E7%A9%82%E5%8C%BA%E7%A5%9E%E5%89%8D%E7%94%BA%EF%BC%92%E4%B8%81%E7%9B%AE%EF%BC%92%EF%BC%90&ll=35.123577,136.934731&spn=0.005265,0.006437&z=16&iwloc=A&output=embed"
    }
  })]), " ", _h('div', {
    staticClass: "text-center"
  }, [_h('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.toggleMapOverlay
    }
  }, [_vm._s(_vm.mapToggleText)])])])]), " ", _h('div', {
    staticClass: "card",
    attrs: {
      "id": "cdr"
    }
  }, [_vm._m(10), " ", _h('div', {
    staticClass: "card-body"
  }), " ", _h('div', {
    staticClass: "card-footer"
  }, [_h('calendar')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "main-image"
  }, [_h('div', {
    staticClass: "title"
  }, [_h('h2', {
    staticClass: "text-center"
  }, ["あなたの体のコリをほぐし", _h('br'), "歪みを整えます"])]), " ", _h('div', {
    staticStyle: {
      "background-image": "url(/images/top-1.jpg)"
    }
  }), " ", _h('div', {
    staticStyle: {
      "background-image": "url(/images/top-2.jpg)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card two-times"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["院長 戸田 光紀"])]), " ", _h('div', {
    staticClass: "card-body text-center"
  }, [_h('img', {
    attrs: {
      "src": "/images/toda_mitsunori.jpg"
    }
  })]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', {
    staticClass: "text-center"
  }, ["院長 戸田光紀"]), " ", _h('p', ["<プロフィール>"]), " ", _h('p', ["１９６７年６月、名古屋市生まれです。", _h('br'), "趣味は、山登りと街や田舎をぶらぶら歩くことです。"]), " ", _h('p', ["私も実は中学生の頃からひどい腰痛持ちで、常に骨盤ベルトをしていないと不安でした。", _h('br'), "病院やいくつかの治療院に通いましたが良くならず、３０代前半の頃、歩くことができないほど腰痛が悪化し、そんな時、飛び込みで入った整体院が、わが師・岡田先生の中国整体治療研究所（千葉県木更津市）でした。"]), " ", _h('p', ["岡田先生に初めて整体を受けたとき、直感的に"]), " ", _h('p', [_h('span', {
    staticClass: "text-bold"
  }, ["「あきらめていた腰痛が良くなる」"])]), " ", _h('p', ["と確信しました。その時の感動を、いまも忘れません。"]), " ", _h('p', ["私のようにあきらめていた人を「", _h('span', {
    staticClass: "text-bold"
  }, ["救いたい"]), "」という思いから、岡田先生のもと修業し、２００２年に名古屋市瑞穂区で「とだ整体」を開所しました。"])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["今月のツボ"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["Facebook"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-footer text-center"
  }, [_h('a', {
    attrs: {
      "href": "https://www.facebook.com/todaseitai.tsubo"
    }
  }, ["Facebookページへ"]), " "])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["今月のツボ"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card two-times2"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["とだ整体の特徴"])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('h5', ["〈健康な体〉は正しい姿勢から"]), " ", _h('p', ["身体の歪みは万病のもと。正しい姿勢こそが〈健康な体〉、元気の源です。"]), " ", _h('p', ["漢方には、その人の体を生活全体から観察し、把握して、体質を改善することにより、根本から「病」を予防するという考え方があります。", _h('br'), "\r\n           当院では、体の痛みを部分的に見るのではなく、その人の体質や姿勢、体の歪みを観察することで全身を把握し、痛みとなる要因を見つけます。その上で、手技により硬くなった筋肉や靭帯をゆるめ、骨格を矯正して体の歪みを整えていきます。"]), " ", _h('p', ["正しい姿勢になることで、人がもともと持つ自然治癒力が高まり、根本から「病」を予防することになるのです。"]), " ", _h('p', ["体の痛みを我慢ている多くの皆様、正しい姿勢を取り戻し、〈元気な体〉で、より楽しい人生をおくりましょう。"])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card two-times3"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["こんな方が来院されています"])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('ul', [_h('li', ["仕事中のパソコン操作で首や肩のコリがつらい"]), " ", _h('li', ["スマホ・ゲームに集中して肩や背中がカチコチだ"]), " ", _h('li', ["長年、頭痛に悩まされている"]), " ", _h('li', ["肉体労働などで腰が痛む　腰がギクリとして怖い"]), " ", _h('li', ["坐骨神経痛で立っても座っても足腰が痛む"]), " ", _h('li', ["膝の痛みで歩くのがつらい"]), " ", _h('li', ["猫背など姿勢が気になる"]), " ", _h('li', ["寝付きが悪い　眠りが浅い"]), " ", _h('li', ["顔の歪み　顎関節が痛む"]), " ", _h('li', ["手足が冷たい　体が冷える"]), " ", _h('li', ["便秘　下痢　胃がもたれる"]), " ", _h('li', ["顔や手足のむくみ　など"])])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["とだ整体 について"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('table', {
    staticClass: "table"
  }, [_h('tbody', [_h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["院名"]), " ", _h('td', ["とだ整体 —中国整体術—"])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["所在地\r\n              "]), " ", _h('td', ["名古屋市瑞穂区神前町２－２０"])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["営業時間"]), " ", _h('td', ["09:00 〜 21:00"])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["定休日"]), " ", _h('td', ["不定休（カレンダーを確認してください。）"])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["料金"]), " ", _h('td', [_h('span', {
    staticClass: "text-bold"
  }, ["5,000円（50分）"]), _h('br')])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["電話番号"]), " ", _h('td', [_h('span', {
    staticClass: "attention"
  }, ["0120-842-275（フリーコール）"]), "※名古屋市及び周辺地域限定\r\n                ", _h('br'), "052-842-2705\r\n              "])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["E-mail"]), " ", _h('td', [_h('a', {
    attrs: {
      "href": "mailto:seitai.toda.2002@gmail.com"
    }
  }, ["seitai.toda.2002@gmail.com"])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["予約・問い合わせについて"]), " ", _h('td', [_h('span', {
    staticClass: "attention"
  }, ["電話予約を優先させていただいております。"]), _h('br'), "\r\n                お問い合わせはE-mailでも受け付けておりますが、施術中などで返信が遅れる場合もありますことをご了承ください。\r\n              "])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["駐車場"]), " ", _h('td', ["店舗の前に１台分有り"])]), " ", _h('tr', [_h('td', {
    staticClass: "text-bold"
  }, ["最寄り駅"]), " ", _h('td', ["\r\n                地下鉄桜通線 瑞穂運動場西④出口 徒歩8分", _h('br'), "\r\n                地下鉄桜通線・名城線 新瑞橋②出口 徒歩10分\r\n              "])])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["お休みカレンダー"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-371def33!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/Home.vue
// module id = 431
// module chunks = 0